<ng-container *ngIf="!otpVerificationDisplay">
  <h3>{{ 'END_CONS_SIGN_UP.TITLE' | translate }}
    <p>
      {{ 'END_CONS_SIGN_UP.SUBTITLE' | translate }}
      <span (click)="toLogin()">{{ 'END_CONS_SIGN_UP.SIGN_IN_LINK' | translate }}</span>
      {{ 'END_CONS_SIGN_UP.SIGN_IN_CONTINUATION' | translate }}
    </p>
  </h3>

  <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
    <!-- Name -->
    <div class="form-group with-icon">
      <label for="name">{{ 'END_CONS_SIGN_UP.FIRST_NAME' | translate }} <span class="req">*</span></label>
      <i class="icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.4167 4.58326L13.75 7.9166M3.75 11.2499L7.08333 14.5833M2.5 15.8333H5.83333L14.5833 7.08326C15.0254 6.64123 15.2737 6.04171 15.2737 5.41659C15.2737 4.79147 15.0254 4.19195 14.5833 3.74993C14.1413 3.3079 13.5418 3.05957 12.9167 3.05957C12.2915 3.05957 11.692 3.3079 11.25 3.74993L2.5 12.4999V15.8333ZM17.5 12.4999V15.8333H10.8333L14.1667 12.4999H17.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </i>
      <input id="name" type="text" formControlName="name" class="form-control"/>
      <div *ngIf="registrationForm.get('name')?.touched && registrationForm.get('name')?.invalid">
        <small class="text-danger">{{ 'END_CONS_SIGN_UP.ERRORS.REQUIRED' | translate }}</small>
      </div>
    </div>

    <!-- Last Name -->
    <div class="form-group with-icon mt-3">
      <label for="lastName">{{ 'END_CONS_SIGN_UP.LAST_NAME' | translate }} <span class="req">*</span></label>
      <i class="icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.4167 4.58326L13.75 7.9166M3.75 11.2499L7.08333 14.5833M2.5 15.8333H5.83333L14.5833 7.08326C15.0254 6.64123 15.2737 6.04171 15.2737 5.41659C15.2737 4.79147 15.0254 4.19195 14.5833 3.74993C14.1413 3.3079 13.5418 3.05957 12.9167 3.05957C12.2915 3.05957 11.692 3.3079 11.25 3.74993L2.5 12.4999V15.8333ZM17.5 12.4999V15.8333H10.8333L14.1667 12.4999H17.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </i>
      <input id="lastName" type="text" formControlName="lastName" class="form-control"/>
      <div *ngIf="registrationForm.get('lastName')?.touched && registrationForm.get('lastName')?.invalid">
        <small class="text-danger">{{ 'END_CONS_SIGN_UP.ERRORS.REQUIRED' | translate }}</small>
      </div>
    </div>

    <!-- Email -->
    <div class="form-group with-icon mt-3">
      <label for="email">{{ 'END_CONS_SIGN_UP.EMAIL' | translate }} <span class="req">*</span></label>
      <i class="icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.5 5.83341C2.5 5.39139 2.67559 4.96746 2.98816 4.6549C3.30072 4.34234 3.72464 4.16675 4.16667 4.16675H15.8333C16.2754 4.16675 16.6993 4.34234 17.0118 4.6549C17.3244 4.96746 17.5 5.39139 17.5 5.83341M2.5 5.83341V14.1667C2.5 14.6088 2.67559 15.0327 2.98816 15.3453C3.30072 15.6578 3.72464 15.8334 4.16667 15.8334H15.8333C16.2754 15.8334 16.6993 15.6578 17.0118 15.3453C17.3244 15.0327 17.5 14.6088 17.5 14.1667V5.83341M2.5 5.83341L10 10.8334L17.5 5.83341" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </i>
      <input id="email" type="email" formControlName="email" class="form-control" />
      <div *ngIf="registrationForm.get('email')?.touched && registrationForm.get('email')?.invalid || (formError && formError.email)">
        <small *ngIf="registrationForm.get('email')?.errors?.['required']" class="text-danger">
          {{ 'END_CONS_SIGN_UP.ERRORS.REQUIRED' | translate }}
        </small>
        <small *ngIf="registrationForm.get('email')?.errors?.['email']" class="text-danger">
          {{ 'END_CONS_SIGN_UP.ERRORS.EMAIL_INVALID' | translate }}
        </small>
        <small *ngIf="formError && formError.email" class="text-danger">
          {{formError.email}}
        </small>
      </div>
    </div>

    <!-- Birth Date -->
    <div class="form-group with-icon mt-3 date-field">
      <label for="birthDate">{{ 'END_CONS_SIGN_UP.BIRTH_DATE' | translate }} <span class="req">*</span></label>
      <i class="icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.3335 2.5V5.83333M6.66683 2.5V5.83333M3.3335 9.16667H16.6668M3.3335 5.83333C3.3335 5.39131 3.50909 4.96738 3.82165 4.65482C4.13421 4.34226 4.55814 4.16667 5.00016 4.16667H15.0002C15.4422 4.16667 15.8661 4.34226 16.1787 4.65482C16.4912 4.96738 16.6668 5.39131 16.6668 5.83333V15.8333C16.6668 16.2754 16.4912 16.6993 16.1787 17.0118C15.8661 17.3244 15.4422 17.5 15.0002 17.5H5.00016C4.55814 17.5 4.13421 17.3244 3.82165 17.0118C3.50909 16.6993 3.3335 16.2754 3.3335 15.8333V5.83333ZM6.66683 12.5H8.3335V14.1667H6.66683V12.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </i>
      <input id="birthDate" type="date" formControlName="birthDate" class="form-control"/>
      <i class="icon icon-chevron-right"></i>
      <small class="field-description field-description--with-icon">
        <span class="field-description__icon" aria-hidden="true">
          <svg width="15" height="15" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="28" fill="none" stroke="currentColor" stroke-width="4" />
            <line x1="32" y1="26" x2="32" y2="42" stroke="currentColor" stroke-width="4" stroke-linecap="round" />
            <circle cx="32" cy="20" r="3" fill="currentColor" />
          </svg>
        </span>
        <span>
          {{ 'END_CONS_SIGN_UP.BIRTH_DATE_DESCRIPTION_LINE1' | translate }}
          {{ 'END_CONS_SIGN_UP.BIRTH_DATE_DESCRIPTION_LINE2' | translate }}
        </span>
      </small>
      <div *ngIf="registrationForm.get('birthDate')?.touched && registrationForm.get('birthDate')?.invalid">
        <small class="text-danger">{{ 'END_CONS_SIGN_UP.ERRORS.REQUIRED' | translate }}</small>
      </div>
    </div>

    <!-- Gender -->
    <div class="form-group with-icon mt-3">
      <label for="gender">{{ 'END_CONS_SIGN_UP.GENDER' | translate }}</label>
      <i class="icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.66667 17.4999H13.3333M10 14.1666V17.4999M10 14.1666C11.1051 14.1666 12.1649 13.7276 12.9463 12.9462C13.7277 12.1648 14.1667 11.105 14.1667 9.99992V3.33325H5.83333V9.99992C5.83333 11.105 6.27232 12.1648 7.05372 12.9462C7.83512 13.7276 8.89493 14.1666 10 14.1666ZM2.5 7.49992C2.5 7.94195 2.67559 8.36587 2.98816 8.67843C3.30072 8.99099 3.72464 9.16659 4.16667 9.16659C4.60869 9.16659 5.03262 8.99099 5.34518 8.67843C5.65774 8.36587 5.83333 7.94195 5.83333 7.49992C5.83333 7.05789 5.65774 6.63397 5.34518 6.32141C5.03262 6.00885 4.60869 5.83325 4.16667 5.83325C3.72464 5.83325 3.30072 6.00885 2.98816 6.32141C2.67559 6.63397 2.5 7.05789 2.5 7.49992ZM14.1667 7.49992C14.1667 7.94195 14.3423 8.36587 14.6548 8.67843C14.9674 8.99099 15.3913 9.16659 15.8333 9.16659C16.2754 9.16659 16.6993 8.99099 17.0118 8.67843C17.3244 8.36587 17.5 7.94195 17.5 7.49992C17.5 7.05789 17.3244 6.63397 17.0118 6.32141C16.6993 6.00885 16.2754 5.83325 15.8333 5.83325C15.3913 5.83325 14.9674 6.00885 14.6548 6.32141C14.3423 6.63397 14.1667 7.05789 14.1667 7.49992Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </i>
      <div class="custom-dropdown">
        <select id="gender" formControlName="gender" class="form-control">
          <option value="" disabled>{{ 'END_CONS_SIGN_UP.GENDER_SELECT' | translate }}</option>
          <option value="male">{{ 'END_CONS_SIGN_UP.MALE' | translate }}</option>
          <option value="female">{{ 'END_CONS_SIGN_UP.FEMALE' | translate }}</option>
        </select>
      </div>
      <i class="icon icon-chevron-right"></i>
    </div>

    <!-- Password -->
    <div class="form-group mt-2">
      <label for="password">{{ 'END_CONS_SIGN_UP.PASSWORD' | translate }} <span class="req">*</span></label>
      <input id="password" class="form-control"
             formControlName="password" [type]="showPassword ? 'text' : 'password'"/>
      <i class="icon password-icon"
         [ngClass]="{'icon-eye': showPassword, 'icon-eye-closed': !showPassword}"
         (click)="togglePasswordVisibility('password')"></i>
      <div *ngIf="registrationForm.get('password')?.touched && registrationForm.get('password')?.invalid">
        <small *ngIf="registrationForm.get('password')?.errors?.['required']" class="text-danger">
          {{ 'END_CONS_SIGN_UP.ERRORS.REQUIRED' | translate }}
        </small>
        <small *ngIf="registrationForm.get('password')?.errors?.['minlength']" class="text-danger">
          {{ 'END_CONS_SIGN_UP.ERRORS.PASSWORD_MIN' | translate }}
        </small>
      </div>
    </div>

    <!-- Confirm Password -->
    <div class="form-group mt-2">
      <label for="confirmPassword">{{ 'END_CONS_SIGN_UP.CONFIRM_PASSWORD' | translate }} <span class="req">*</span></label>
      <input id="confirmPassword" class="form-control"
             [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" />
      <i class="icon password-icon"
         [ngClass]="{'icon-eye': showConfirmPassword, 'icon-eye-closed': !showConfirmPassword}"
         (click)="togglePasswordVisibility('confirmPassword')"></i>
      <div *ngIf="registrationForm.get('confirmPassword')?.touched && (registrationForm.get('confirmPassword')?.invalid || registrationForm.hasError('passwordsMismatch'))">
        <small *ngIf="registrationForm.get('confirmPassword')?.errors?.['required']" class="text-danger">
          {{ 'END_CONS_SIGN_UP.ERRORS.REQUIRED' | translate }}
        </small>
        <small *ngIf="registrationForm.get('confirmPassword')?.errors?.['minlength']" class="text-danger">
          {{ 'END_CONS_SIGN_UP.ERRORS.CONFIRM_PASSWORD_MIN' | translate }}
        </small>
        <small *ngIf="registrationForm.hasError('passwordsMismatch')" class="text-danger">
          {{ 'END_CONS_SIGN_UP.ERRORS.PASSWORDS_MISMATCH' | translate }}
        </small>
      </div>
    </div>

    <!-- Phone -->
    <div class="form-group with-icon mt-3">
      <label for="phone">{{ 'END_CONS_SIGN_UP.PHONE' | translate }} <span class="req">*</span></label>
      <i class="icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.16667 3.33325H7.5L9.16667 7.49992L7.08333 8.74992C7.9758 10.5595 9.44039 12.0241 11.25 12.9166L12.5 10.8333L16.6667 12.4999V15.8333C16.6667 16.2753 16.4911 16.6992 16.1785 17.0118C15.866 17.3243 15.442 17.4999 15 17.4999C11.7494 17.3024 8.68346 15.922 6.38069 13.6192C4.07792 11.3165 2.69754 8.25053 2.5 4.99992C2.5 4.55789 2.67559 4.13397 2.98816 3.82141C3.30072 3.50885 3.72464 3.33325 4.16667 3.33325Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </i>
      <ngx-intl-tel-input
        [cssClass]="'form-control phone-control'"
        [enableAutoCountrySelect]="false"
        [enablePlaceholder]="isBrowser"
        [searchCountryFlag]="true"
        [searchCountryField]="searchCountryFields"
        [selectFirstCountry]="false"
        [preferredCountries]="preferredCountries"
        [onlyCountries]="onlyCountries"
        [phoneValidation]="true"
        [separateDialCode]="true"
        [maxLength]="15"
        [selectedCountryISO]="selectedCountryISO"
        (countryChange)="onPhoneCountryChange($event)"
        inputId="phone"
        formControlName="phone">
      </ngx-intl-tel-input>
      <div *ngIf="registrationForm.get('phone')?.touched && registrationForm.get('phone')?.invalid || (formError && formError.profile)">
        <small *ngIf="registrationForm.get('phone')?.errors?.['required']" class="text-danger">
          {{ 'END_CONS_SIGN_UP.ERRORS.REQUIRED' | translate }}
        </small>
        <small *ngIf="registrationForm.get('phone')?.errors?.['validatePhoneNumber']" class="text-danger">
          {{ 'END_CONS_SIGN_UP.ERRORS.PHONE_INVALID' | translate }}
        </small>
        <small *ngIf="formError && formError.profile.includes('phone_number')" class="text-danger">
          {{ 'END_CONS_SIGN_UP.ERRORS.PHONE_EXISTS' | translate }}
        </small>
      </div>
    </div>

    <div class="form-check mt-3">
      <input type="checkbox" formControlName="emailSubscription" />
      <label>{{ 'END_CONS_SIGN_UP.EMAIL_SUBSCRIPTION' | translate }}</label>
    </div>

    <div class="form-check mt-3 mb-3">
      <input type="checkbox" formControlName="confirmTerms" />
      <label>
        {{'SUBSCRIPTION.ACCEPT_1' | translate}} <a (click)="goToTermsConditions()" target="_blank">{{'SUBSCRIPTION.T&C' | translate}}</a>
        {{'SUBSCRIPTION.ACCEPT_2' | translate}} <a (click)="goToPrivacyPolicy()">{{'SUBSCRIPTION.P&P' | translate}}</a>
        <span class="text-danger">*</span>
      </label>
      <div *ngIf="registrationForm.get('confirmTerms')?.invalid && (registrationForm.get('confirmTerms')?.touched || submitted)">
        <small class="text-danger">{{ 'END_CONS_SIGN_UP.ERRORS.REQUIRED' | translate }}</small>
      </div>
    </div>

    <!-- Submit Button -->
    <small *ngIf="error" class="text-danger">
      {{errorMessage}}
    </small>
    <button type="submit" class="btn btn-primary with-loader" [disabled]="!registrationForm.valid">
      {{ 'END_CONS_SIGN_UP.SUBMIT_BUTTON' | translate }}
      <span class="loader" *ngIf="loading"></span>
    </button>
  </form>
</ng-container>

<ng-container *ngIf="otpVerificationDisplay">
  <app-otp [phoneNumber]="phoneNumber" [giPantMode]="true"></app-otp>
</ng-container>
